import React, { useState } from "react";
import BlogData from "./BlogData";
import Modal from "react-bootstrap/Modal";
import { Grid } from "@mui/material";
import "./Blog.css";

const Blog = () => {
  const [modalShow, setModalShow] = useState(false);

  function MyVerticallyCenteredModal(props) {
    const details = props.data.details.replace(/\n/g, " ");
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>{props.data.name}</h4>
          <div className="blog-photo-div">
            <img src={props.data.photo} alt="blog1" className="img-fluid" />
          </div>

          <h5 className="display-linebreak" style={{ marginTop: "20px" }}>
            {props.data.details}
          </h5>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <div className="BG-Blog" id="blog">
      <div className="container" style={{ paddingBottom: "50px" }}>
        <div className="after">
          <h1>My Blogs</h1>
          <Grid container spacing={2}>
            {BlogData.map((data) => {
              return (
                <Grid item xs={12} md={6} lg={4}>
                  <div className="portfolio-box">
                    <div className="content-box">
                      <img src={data.photo} alt={data.name} />
                    </div>
                    <h3
                      style={{
                        marginTop: "8px",

                        fontWeight: "bold",
                      }}
                    >
                      {data.name}
                    </h3>

                    <button
                      onClick={() => setModalShow(true)}
                      style={{ marginTop: "8px" }}
                      type="button"
                      class="btn btn-danger"
                    >
                      See Details{" "}
                    </button>
                    <MyVerticallyCenteredModal
                      data={data}
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                    />
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Blog;
